export default {
  root: {
    class: [
      // Shape
      "rounded-md",

      // Spacing
      "p-2 sm:p-4", // Adjusted padding for smaller screens

      // Color
      "bg-surface-0 dark:bg-surface-900",

      // Responsive Scrolling
      "overflow-x-auto whitespace-nowrap", // Enables horizontal scroll on small screens
    ],
  },
  list: {
    class: [
      // Flex & Alignment
      "flex items-center flex-nowrap sm:flex-wrap", // Wraps only on larger screens

      // Spacing
      "m-0 p-0 list-none leading-none gap-2 sm:gap-3",
    ],
  },
  itemLink: {
    class: [
      // Flex & Alignment
      "flex items-center gap-2",

      // Shape
      "rounded-md px-2 sm:px-4 py-1 sm:py-2", // Improves touch usability

      // Color & Contrast
      "text-surface-600 dark:text-white/70",

      // Hover & Active States
      "hover:bg-gray-100 dark:hover:bg-gray-800",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400",

      // Smooth Transitions
      "transition-all duration-200 ease-in-out",

      // Text Handling
      "text-decoration-none truncate max-w-[100px] sm:max-w-full", // Ensures long text doesn't break UI
    ],
  },
  itemIcon: {
    class: "text-surface-600 dark:text-white/70",
  },
  separator: {
    class: [
      // Flex & Alignment
      "flex items-center",

      // Spacing
      "mx-2 sm:mx-3", // Adds more space between items on large screens

      // Color
      "text-surface-600 dark:text-white/70",
    ],
  },
};
